import { render, staticRenderFns } from "./CheckupRiskGraphic.vue?vue&type=template&id=706e462c&scoped=true&"
import script from "./CheckupRiskGraphic.vue?vue&type=script&lang=js&"
export * from "./CheckupRiskGraphic.vue?vue&type=script&lang=js&"
import style0 from "./CheckupRiskGraphic.vue?vue&type=style&index=0&id=706e462c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706e462c",
  null
  
)

export default component.exports